require('../playerSharedDataService');
require('../../shared/singleClipService');
require('../../shared/singleGameService');
require('./timelineService');

angular.module('app.player.timelineController', [
  'app.player.playerSharedDataService',
  'app.shared.singleClipService',
  'app.shared.singleGameService',
  'app.player.timelineService'
])
  .controller('app.player.timelineController', [
    '$scope',
    'app.player.playerSharedDataService',
    'app.shared.singleClipService',
    'app.shared.singleGameService',
    'app.player.timelineService',
    '$rootScope',
    '$state',
    '$filter',
    function ($scope, playerSharedData, singleClip, singleGame, timelineService, $rootScope, $state, $filter) {
      "use strict";

      let prevSelectedIndex = -1;
      $scope.timelineService = timelineService;
      $scope.dashIcon = '<i class="fa fa-minus"><i>';
      $scope.audioControlsVisible = null;
      $scope.eventsDivHeight = null;
      $scope.game = singleGame;
      $scope.timelineEvents = [];

      $scope.eventActions = [
        {
          title: 'Delete',
          class: 'btn btn-danger',
          action: (event) => {
            let remove = confirm("Are you sure you want to delete this clip?");
            if (remove) {
              singleClip.delete(event.iclipid).then(function (response) {
                if (response.status === 204) {
                  if (singleGame.data) {
                    let eventToDeleteIndex = singleGame.clips.findIndex((clip) => {
                      return clip.iclipid === event.iclipid
                    });

                    if(eventToDeleteIndex > -1) {
                      event.is_collapsed = true;
                      singleGame.clips.splice(eventToDeleteIndex, 1);
                      assignGameClips();
                    }
                  }
                } else if (response.data && response.data.error) {
                  alert(response.data.error);
                }
              });
            }
          },
          hide: () => {
          }
        },
        {
          title: 'Edit',
          class: 'btn btn-success',
          action: (event) => {
            $scope.playClip(event);

            let new_event = event;

            delete new_event.is_collapsed;

            $rootScope.$broadcast('instant_replay_created', {clip: new_event, editing: true, show_editor: true});
          }
        },
        {
          title: 'Syndicate Clip',
          class: 'btn btn-success',
          action: (event) => {
            singleClip.syndicate(event.iclipid)
              .then((response) => {
                let data = response.data;

                if (data.error) {
                  alert(data.error);
                } else {
                  alert('Your clip is being prepared. We will email you the clip when it is ready.');
                }
              });
          },
          hide: (event) => {
            return !event.can_syndicate;
          }
        }

        /*{
          title: 'Open Video Analysis Page',
          class: 'btn btn-success',
          action: (event) => {
            $state.go('app.admin.videoAnalysis.myClips', {selected_clip: JSON.stringify(event)});
          }
        },*/
      ];

      $scope.pager = {
        items: [],
        pageSize: 10,
        currentPage: 1,
        pageChanged: function () {
          if (Array.isArray(singleGame.clips)) {
            let start = (this.currentPage - 1) * this.pageSize;
            let end = start + this.pageSize;

            this.items = singleGame.clips.slice(start, end);
          }
        },
        reset: function () {
          this.currentPage = 1;
          this.pageChanged();
        },
      };

      let init = () => {
        $scope.timelineService.sortColumnHeaders();
        $scope.timelineService.assignSelectedHeaders();
      };

      let tdStyleHelper = function(e, tr) { //fixes style issue of td cells not displaying correct while item is being dragged.
        let $originals = tr.children();
        let $helper = tr.clone();
        $helper.children().each(function(index)
        {
          $(this).width($originals.eq(index).width());
          $(this).height($originals.eq(index).height())
        });
        return $helper;
      };

      $scope.sortableOptions = {
        helper: tdStyleHelper,
        cancel: ".deselected_header"
      };

      let timeLineCanvasPoint = {
        color: '#7ed321',
        width: 10,
        height: 10
      };



      $scope.setTimeLineCanvas = () => {
        if (Array.isArray(singleGame.clips)) {
          let timeLineCanvas = document.getElementById('timeLineCanvas');

          if (timeLineCanvas) {
            let context = timeLineCanvas.getContext("2d");

            context.clearRect(0, 0, 300, 149);
            _.forEach(singleGame.clips, (event) => {
              event.ilocx = parseInt(event.ilocx) || 0;
              event.ilocy = parseInt(event.ilocy) || 0;

              if (event.ilocx || event.ilocy) {
                context.beginPath();
                context.fillStyle = timeLineCanvasPoint.color;
                context.arc(
                  event.ilocx, event.ilocy,
                  (timeLineCanvasPoint.width / 2),
                  0, 2 * Math.PI
                );
                context.stroke();
                context.lineWidth = 4;
                context.fill();
              }
            });
          }
        }
      };

      $scope.timeLineCanvasClick = (event) => {
        let foundClip = null,
          foundIndex = null;

        let click_x = event.offsetX;
        let click_y = event.offsetY;

        _.forEach(singleGame.clips, (clip, i) => {
          let start_x = clip.ilocx;
          let end_x = clip.ilocx + timeLineCanvasPoint.width;
          let start_y = clip.ilocy;
          let end_y = clip.ilocy + timeLineCanvasPoint.height;

          if (click_x >= start_x && click_x <= end_x) {
            if (click_y >= start_y && click_y <= end_y) {
              foundIndex = i;
              foundClip = clip;
              return false;
            }
          }
        });

        if (foundClip) {
          if (prevSelectedIndex > -1) {
            singleGame.clips[prevSelectedIndex].highlight = false;
          }
          prevSelectedIndex = foundIndex;
          singleGame.clips[foundIndex].highlight = true;
          $scope.playClip(foundClip);
        }
      };

      $scope.onPlayClip = (event) => {
        if (prevSelectedIndex > -1) {
          singleGame.clips[prevSelectedIndex].highlight = false;
        }
        $scope.playClip(event);
      };

      $scope.getClipDatum = (clip_datum, clip) => {
        if(angular.isObject(clip_datum)) {
          clip_datum.position = clip_datum.position.toLowerCase();

          if(clip_datum.team === 'away') {
            return clip.lines.away[clip_datum.position];
          } else {
            return clip.lines.home[clip_datum.position];
          }
        } else {
          switch (clip_datum) {
            case 'clip_name':
              return clip.strclipname;

            case 'game_date':
              return $filter('date')(clip.game.dtegametimefixed, 'MMM. dd, yyyy');

            case 'matchup':
              return clip.game.league.strleaguenickname
                + ': ' + clip.game.awayteam.abbrev
                + ' @ ' + clip.game.hometeam.abbrev;

            case 'category':
              if(clip.category) {
                return clip.category.strclipcategory;
              } else if(clip.clip_category) {
                return clip.clip_category.strclipcategory
              } else {
                return null
              }
            case 'clip_time':
              return $filter('left_pad')(clip.startClockTime.hour, 2)
                + ':' + $filter('left_pad')(clip.startClockTime.minute, 2)
                + ':' + $filter('left_pad')(clip.startClockTime.second, 2);

            case 'duration':
              return $filter('left_pad')(clip.clockTime.hour, 2)
                + ':' + $filter('left_pad')(clip.clockTime.minute, 2)
                + ':' + $filter('left_pad')(clip.clockTime.second, 2);

            case 'clock_time':
              return clip.game_clocktime;

            case 'period':
              return clip.iperiod;

            case 'subcategory':
              return clip.subcategory ? clip.subcategory.subcategory : null;

            case 'strength':
              return clip.subcategory_strength ? clip.subcategory_strength.strength : null;
          }
        }
      };

      $scope.assignHeaders = (show_table_data) => {
        $scope.timelineService.assignSelectedHeaders();

        if(!show_table_data) {
          $scope.timelineService.sortColumnHeaders();
        }
      };

      $scope.getRowBackgroundColor = (index) => {
        if ((index+1) % 2 === 0) {
          return 'even'
        } else {
          return 'odd';
        }
      };

      $scope.getClips = () => {
        if (singleGame.data) {
          singleGame.getMoreClips();
        }
      };

      let assignGameClips = () => {
        $scope.timelineEvents = singleGame.clips;

        _.forEach($scope.timelineEvents, (clip) => {
            clip.is_collapsed = true;
        });

        $scope.pager.pageChanged();
        $scope.setTimeLineCanvas();
      };

      $scope.$watch(() => {
        return singleGame.clips
      }, () => {
        assignGameClips();
      });

      $scope.$on('assign_timeline_clips', () => {
        assignGameClips();
      });

      $scope.$on('timelineIsAudioVisible', () => {
        if(singleGame.data) {
          $scope.audioControlsVisible = (singleGame.data.multiple_audio_setting === 1 || singleGame.data.multiple_audio_setting === 2) && $scope.type === 'game';
        }
      });

      return init();
    }

  ]);


// WEBPACK FOOTER //
// ./app.v2/components/player/timeline/timelineController.js